import axios from "axios";

export default {
  async getMenuForServiceAndTable(service, tableId, isPda, pdaId) {
    let endpoint = `/menu/departments/${service}?tableId=${tableId}`;
    if (isPda) {
      endpoint = endpoint + "&isPda=true";
    }
    if (pdaId) {
      endpoint = endpoint + "&pdaId=" + pdaId;
    }
    let result = await axios.get(endpoint);
    return result.data;
  },

  async getMenuForEdit(restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/menu/by-waiter?restaurantId=${restaurantId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getSubSelectionCategoriesForEdit(restaurantId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .get(`${adminBaseUrl}/product-subselection/all?restaurantId=${restaurantId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },


  async editCategory(restaurantId, payload, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(`${adminBaseUrl}/restaurant/v2/product-category-by-waiter?restaurantId=${restaurantId}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      });
  },

  async createCategory(restaurantId, payload, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(`${adminBaseUrl}/restaurant/v2/product-category/by-waiter?restaurantId=${restaurantId}`, payload, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      });
  },

  async deleteCategory(restaurantId, productCategoryId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .delete(`${adminBaseUrl}/restaurant/product-category-by-waiter?restaurantId=${restaurantId}&productCategoryId=${productCategoryId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async editProduct(restaurantId, productId, productCategoryId, payload, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .put(
        `${adminBaseUrl}/product/v2/by-waiter?restaurantId=${restaurantId}&productId=${productId}&productCategoryId=${productCategoryId}`,
        payload,
        {
          headers: {
            "AUTH-TOKEN": authToken,
            "AUTH-JWT": jwt,
          },
        }
      )
      .then((response) => {
        return response.data;
      });
  },

  async createProduct(restaurantId, productCategoryId, payload, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .post(
        `${adminBaseUrl}/product/v2/by-waiter?restaurantId=${restaurantId}&productCategoryId=${productCategoryId}`,
        payload,
        {
          headers: {
            "AUTH-TOKEN": authToken,
            "AUTH-JWT": jwt,
          },
        }
      )
      .then((response) => {
        return response.data;
      });
  },

  async uploadProductPhoto(restaurantId, storeId, productId, file, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    let formData = new FormData();
    formData.append("file", file);
    return axios
      .post(
        `${adminBaseUrl}/files/product-photo?productId=${productId}&restaurantId=${restaurantId}&storeId=${storeId}`,
        formData,
        {
          headers: {
            "AUTH-TOKEN": authToken,
            "AUTH-JWT": jwt,
          },
        }
      )
      .then((response) => {
        return response.data;
      });
  },

  async updateProductSubselections(restaurantId, productId, subselectionCategoryIds, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    let idsParam = subselectionCategoryIds.join(",");
    return axios
      .post(
        `${adminBaseUrl}/product/subselections/by-waiter?restaurantId=${restaurantId}&productId=${productId}&subselectionCategoryIds=${idsParam}`,
        null,
        {
          headers: {
            "AUTH-TOKEN": authToken,
            "AUTH-JWT": jwt,
          },
        }
      )
      .then((response) => {
        return response.data;
      });
  },

  async deleteProduct(restaurantId, productId, authToken, jwt) {
    let adminBaseUrl = process.env.VUE_APP_ADMIN_URL;
    return axios
      .delete(`${adminBaseUrl}/product/by-waiter?restaurantId=${restaurantId}&productId=${productId}`, {
        headers: {
          "AUTH-TOKEN": authToken,
          "AUTH-JWT": jwt,
        },
      })
      .then((response) => {
        return response.data;
      })
      .catch((error) => {
        console.log(error.response)
      });
  },

  async getFilteredMenu(restaurantId, ids) {
    let idsAsString = ids.join();
    let result = await axios.get(`/menu/filtered?categoryIds=${idsAsString}&restaurantId=${restaurantId}`)

    return result.data;
  },

  async getServices(tableId) {
    return axios
      .get(`/menu/departments?tableId=${tableId}`)
      .then((response) => {
        return response.data;
      })
      .catch((error) => console.log(error.response));
  },

  async increaseMenuScans(serviceId) {
    axios.post(`/restaurant/increase-scan-count?restaurantId=${serviceId}`)
      .catch((error) => console.log(error));
  }
};
